import type { ColorIndicator } from '@disco/utils/color-indicators'
import { COLORS } from '@disco/utils/color-indicators'

const STYLE_ELEMENT_ID = 'indicator-color-classes'
const CLASS_PREFIX = 'indicatorColor-'

const classNameFor = (color: ColorIndicator): string =>
  `${CLASS_PREFIX}${color}`

let injected = false

// Build one background utility class per palette entry and inject it once, so the
// dots can pick a colour by className instead of an inline style. The palette in
// color-indicators.ts stays the single source of truth — the classes are derived
// from it, so a new colour is covered automatically with no hex duplicated here.
const ensureInjected = (): void => {
  if (injected || typeof document === 'undefined') return
  injected = true

  // The id guard covers a second module instance (e.g. HMR) re-injecting.
  if (document.getElementById(STYLE_ELEMENT_ID)) return

  const css = Object.entries(COLORS)
    .map(([color, hex]) => `.${classNameFor(color)}{background:${hex};}`)
    .join('')

  const style = document.createElement('style')
  style.id = STYLE_ELEMENT_ID
  style.textContent = css
  document.head.appendChild(style)
}

// className that paints an element with the given indicator colour. Injection is
// deferred to first use so merely importing the module (e.g. with the feature
// flag off) adds nothing to the document.
export const indicatorColorClass = (color: ColorIndicator): string => {
  ensureInjected()
  return classNameFor(color)
}
